export default __webpack_public_path__ + "locales/es/People.json?hash=03fc8a53a67614ebdbeca35f964e7a45";